/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreMenus } from '../../models/store-menus';

export interface StoresStoreIdMenusGet$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
}

export function storesStoreIdMenusGet(http: HttpClient, rootUrl: string, params: StoresStoreIdMenusGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreMenus>> {
  const rb = new RequestBuilder(rootUrl, storesStoreIdMenusGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreMenus>;
    })
  );
}

storesStoreIdMenusGet.PATH = '/stores/{storeId}/menus';
